import React from 'react'
import './Timeline.css'
import TimelineItem from './TimelineItem'

/**
 * 타임라인 메인 컨테이너 컴포넌트
 */
function Timeline({ 
  sections,
  editingSection,
  setEditingSection,
  isGeneratingTTS,
  isConvertingMp4,
  uploadingMediaSections,
  selectedVoice,
  subtitleSettings,
  titleSettings,
  videoSettings,
  isSidebarOpen,
  onSectionTextUpdate,
  onFileUpload,
  onFileDrop,
  onRemoveSection,
  onRemoveMedia,
  onGenerateTTS,
  onBulkImageUpload,
  onAudioUpload,
  onPreviewClick
}) {
  return (
    <section 
      className="timeline-section"
    >
      <div className="timeline-header">
        <h2>타임라인 {sections.length > 0 && `(${sections.length}개 구간)`}</h2>
        {sections.length > 0 && onPreviewClick && (
          <button 
            className="preview-button-header"
            onClick={onPreviewClick}
          >
            미리보기
          </button>
        )}
      </div>
      <div className={`timeline-container ${!isSidebarOpen ? 'sidebar-closed' : ''}`}>
        {sections.length === 0 ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'start',
              alignItems: 'center',
              color: '#ffffff70',
              fontWeight: '300',
              padding: '20px',
            }}
          >
            타임라인이 없습니다.
          </div>
        ) : (
          sections.map((section) => (
            <TimelineItem
              key={section.id}
              section={section}
              index={section.index || sections.indexOf(section) + 1}
              editingSection={editingSection}
              setEditingSection={setEditingSection}
              isGeneratingTTS={isGeneratingTTS[section.id] || false}
              isConvertingMp4={isConvertingMp4[section.id] || false}
              isUploadingMedia={uploadingMediaSections?.[section.id] || false}
              selectedVoice={selectedVoice}
              subtitleSettings={subtitleSettings}
              titleSettings={titleSettings}
              videoSettings={videoSettings}
              onTextUpdate={onSectionTextUpdate}
              onFileUpload={onFileUpload}
              onFileDrop={onFileDrop}
              onRemove={onRemoveSection}
              onRemoveMedia={onRemoveMedia}
              onGenerateTTS={onGenerateTTS}
              onAudioUpload={onAudioUpload}
            />
          ))
        )}
      </div>
    </section>
  )
}

export default Timeline